// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.fixtimeline {
    padding: 0.25em;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border-color);
}

div.fixtimeline-toolbar {
    display: flex;
    font-size: 70%;
}

div.fixtimeline-toolbar-spacer {
    flex: 1 1 auto;
}

div.fixtimeline-slider {
    position: relative;
}

button.fixtimeline-pan-left,
button.fixtimeline-pan-right {
    touch-action: none;
    position: absolute;
    bottom: 0;
    top: 0;
    width: 1.5em;
    height: initial;
    z-index: 1;
}

button.fixtimeline-pan-left {
    left: 0;
}

button.fixtimeline-pan-right {
    right: 0;
}

div.fixtimeline-ticks {
    margin-top: 2em;
    position: relative;
    height: 10px;
}

div.fixtimeline-ticks > span.fixtimeline-ltick {
    position: absolute;
    display: inline-block;
    width: 2px;
    height: 100%;
    background-color: black;
}

div.fixtimeline-ticks > span.fixtimeline-ltick > span {
    position: absolute;
    width: 10em;
    text-align: center;
    white-space: pre;
    font-size: 70%;
    left: -5em;
    top: -2.5em;
}

div.fixtimeline-ticks > span.fixtimeline-tick {
    position: absolute;
    display: inline-block;
    width: 2px;
    height: 50%;
    bottom: 0;
    background-color: gray;
}

div.fixtimeline-ticks > span.fixtimeline-ltick:first-child,
div.fixtimeline-ticks > span.fixtimeline-ltick:last-child {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/timeline/style/FixedTimeline.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,SAAS;IACT,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;AACjB","sourcesContent":["div.fixtimeline {\n    padding: 0.25em;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--border-color);\n}\n\ndiv.fixtimeline-toolbar {\n    display: flex;\n    font-size: 70%;\n}\n\ndiv.fixtimeline-toolbar-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.fixtimeline-slider {\n    position: relative;\n}\n\nbutton.fixtimeline-pan-left,\nbutton.fixtimeline-pan-right {\n    touch-action: none;\n    position: absolute;\n    bottom: 0;\n    top: 0;\n    width: 1.5em;\n    height: initial;\n    z-index: 1;\n}\n\nbutton.fixtimeline-pan-left {\n    left: 0;\n}\n\nbutton.fixtimeline-pan-right {\n    right: 0;\n}\n\ndiv.fixtimeline-ticks {\n    margin-top: 2em;\n    position: relative;\n    height: 10px;\n}\n\ndiv.fixtimeline-ticks > span.fixtimeline-ltick {\n    position: absolute;\n    display: inline-block;\n    width: 2px;\n    height: 100%;\n    background-color: black;\n}\n\ndiv.fixtimeline-ticks > span.fixtimeline-ltick > span {\n    position: absolute;\n    width: 10em;\n    text-align: center;\n    white-space: pre;\n    font-size: 70%;\n    left: -5em;\n    top: -2.5em;\n}\n\ndiv.fixtimeline-ticks > span.fixtimeline-tick {\n    position: absolute;\n    display: inline-block;\n    width: 2px;\n    height: 50%;\n    bottom: 0;\n    background-color: gray;\n}\n\ndiv.fixtimeline-ticks > span.fixtimeline-ltick:first-child,\ndiv.fixtimeline-ticks > span.fixtimeline-ltick:last-child {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
